import React from 'react';
import { TableBody } from '@mui/material';
export default function Body(_a) {
    var children = _a.children;
    return (React.createElement(TableBody, null, children));
}
